module.exports = __webpack_public_path__ + "img/onBanner1@2x.6557ca2e.svg";